<template>
	<div class="width-100 height-100">
		<div class="width-100 display-flex flex-row flex-align-center flex-justify-space-between py-7 pr-6">
			<div>
				<div>
					<div class="title-text">Spaces</div>
					<span class="description-text">
						Spaces let you organize your work and collaborate.<br />Visible Only to space collaborators, and workspace admins.
					</span>
				</div>
			</div>

			<div v-if="canCreateNewSpace">
				<AnemicButton @click="createNewProject" class="new-button">New Space</AnemicButton>
			</div>
		</div>
		<AllProjectDetails v-if="!isLoading" />
		<AppLoader v-else />
	</div>
</template>

<script>
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';
import { getAccountMembers } from '@/store/modules/account/actions';
import { hasAccountPermission } from '@/store/modules/account/getters';
import { getAllProjectShareData, getAllProjects } from '@/store/modules/projects/actions';
import AllProjectDetails from '@/components/Project/AllProjectDetails.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'AllProjects',
	components: {
		AllProjectDetails,
	},
	computed: {
		...mapGettersShorthand({ hasAccountPermission }),
		canCreateNewSpace() {
			return this.hasAccountPermission(AccountPermissions.CreateProjects);
		},
	},
	methods: {
		...mapActionsShorthand({ getAccountMembers, getAllProjectShareData, getAllProjects }),
		createNewProject() {
			AppDialogManagerService.openNewProjectDialog();
		},
	},
	async created() {
		await this.getAllProjects({ forceGet: true, includingWorkspaceAdminProjects: true });
		await this.getAccountMembers();
		await this.getAllProjectShareData({});
		this.isLoading = false;
	},
	data() {
		return {
			isLoading: true,
		};
	},
};
</script>

<style scoped lang="scss">
.new-button {
	width: 145px !important;
	padding: 0px !important;
	height: 45px !important;
	border-radius: 8px !important;
	background-color: #6762f0 !important;

	color: var(--bg-color);
	font-size: 14px !important;
	font-weight: normal !important;
}
.title-text {
	font-size: 20px;
	letter-spacing: 0px;
	text-align: left;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 14px;
	color: #a3a3a3;
	text-align: left;
	letter-spacing: 0px;
}
</style>
